import { useParams } from 'react-router';
import { ApiError } from '../../lib/api';
import { ShellSkeleton } from '../../shell/ShellSkeleton';
import { AdminAccountFlow } from './admin/AdminAccountFlow';
import { AcceptInvitation } from './user/AcceptInvitation';
import { usePublicInvitation } from './user/api';
import styles from './WelcomeRoute.module.css';

/**
 * `/welcome/:token` (public): the invitation decides the flow — the first admin of a new organization gets F1's
 * account flow (Admin 01/02, M1), everybody else Nutzer 01/M1. Unknown links answer 404, expired, revoked or used
 * ones 410.
 */
export function WelcomeRoute() {
  const token = useParams()['token'] ?? '';
  const invitation = usePublicInvitation(token);

  if (invitation.isPending) return <ShellSkeleton />;
  if (invitation.isError) {
    const expired = invitation.error instanceof ApiError && invitation.error.status === 410;
    const unknown = invitation.error instanceof ApiError && invitation.error.status === 404;
    return (
      <main className={styles.page}>
        <div className={styles.card} role="alert">
          <span className={styles.wordmark}>DAMOKLES</span>
          <h1 className={styles.title}>
            {expired
              ? 'Diese Einladung ist abgelaufen.'
              : unknown
                ? 'Diese Einladung ist ungültig.'
                : 'Die Einladung konnte nicht geladen werden.'}
          </h1>
          <p className={styles.text}>
            {expired || unknown
              ? 'Bitten Sie die Person, die Sie eingeladen hat, um eine neue Einladung.'
              : invitation.error.message}
          </p>
        </div>
      </main>
    );
  }
  if (invitation.data.kind === 'first_admin') {
    return <AdminAccountFlow token={token} invitation={invitation.data} />;
  }
  return <AcceptInvitation token={token} invitation={invitation.data} />;
}
